export class Range {
    private initialValue: any;
    private finalValue: any;

    constructor(initialValue?: any, finalValue?: any) {
        this.initialValue = initialValue || '';
        this.finalValue = finalValue || '';
    }
}
